import ConsoleApi from "apps/console/enums/consoleApi";
import MyExpApi from "apps/myExperience/enum/MyExpApi";
import { usePostApiData } from "shared/datalayer";
import { ApiUrlType } from "shared/datalayer/type";
import TextEnhancementRequest from "shared/types/ai/TextEnhancementRequest";
import TextEnhancementResponse from "shared/types/ai/TextEnhancementResponse";
import { getEnvironmentInfo } from "shared/utils/config";
import { AppType } from "shared/utils/enums";

export function useAITextEnhancement() {
  let apiToUse = "";
  switch (getEnvironmentInfo().appType) {
    case AppType.CONSOLE:
      apiToUse = ConsoleApi.AI_TEXT_ENHANCEMENT;
      break;
    case AppType.MYEXPERIENCE:
      apiToUse = MyExpApi.AI_TEXT_ENHANCEMENT;
  }

  return usePostApiData<TextEnhancementResponse, TextEnhancementRequest>(apiToUse as ApiUrlType, {
    hideLoader: true
  });
}
